<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Galería</h1>
		</div>
	</div>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col-md-4" style="display: inline-block;" *ngIf="showDirectorios">
				<label>Fecha Inicial</label>
				<dx-date-box [(value)]="fechaInicio" type="datetime" [width]="400" displayFormat="yyyy-MM-dd HH:mm:ss"
					style="margin:0 auto;">
				</dx-date-box>
			</div>
			<div class="col-md-4" style="display: inline-block;" *ngIf="showDirectorios">
				<label>Fecha Final</label>
				<dx-date-box [(value)]="fechaFin" type="datetime" [width]="400" displayFormat="yyyy-MM-dd HH:mm:ss"
					style="margin:0 auto;">
				</dx-date-box>
			</div>
			<div class="col-md-4" style="display: inline-block; top: 25px;">
				<button *ngIf="showDirectorios" id="botonBuscar" type="submit" class="btn btn-success"
					(click)="reporteFotos(fechaInicio, fechaFin)"><i class="fal fa-search"></i>Buscar</button>&nbsp;
			</div>
		</div>
		<mat-divider *ngIf="showDirectorios" class="mt-4"></mat-divider>
		<div class="row mt-3">
			<div class="col-md-4 directorios" *ngIf="showDirectorios">
				<ul *ngFor="let dir of directorios;">
					<a (click)="obtenerArchivos(dir.nombre)"><i class="fa fa-folder"></i>&nbsp;{{dir.nombre}}</a>
				</ul>
			</div>
			<div class="col-md-4 directorios" *ngIf="!showDirectorios">
				<i class="fa fa-arrow-circle-left back" (click)="regresarCarpetas()"></i>
				<ul *ngFor="let foto of fotosCarpeta;">
					<a class="folder" (click)="obtenerFotoCarpeta(foto.foto)">
						{{foto.fecha | date:'dd/MM/yyyyh:mm:ss'}}</a>
				</ul>
			</div>
			<div class="col-md-8">
				<div class="col-md-12" style="margin:0 auto; text-align: center;" *ngIf="galeria">
					<button *ngIf="showDirectorios" id="botonBuscar" type="submit" class="btn btn-success"
						(click)="prev()"><i class="fa fa-arrow-left"></i></button>
					<strong class="ml-5">{{i}} / {{galeria.length}}</strong>
					<button *ngIf="showDirectorios" id="botonBuscar" type="submit" class="btn btn-success"
						style="margin-left: 3rem;" (click)="next()"><i class="fa fa-arrow-right"></i></button>
				</div>
				<mat-card class="mt-3" [hidden]="loading">
					<img #myImage class="card">
					<div class="date-text">{{fechaImagen}}</div>
				</mat-card>
				<mat-card [hidden]="!loading" class="loading">
					<mat-progress-spinner color="primary" mode="indeterminate">
					</mat-progress-spinner>
				</mat-card>
			</div>
		</div>
	</div>
</div>
